import { BaseContainerModel } from "../../base-container.model";
import { alg_bot_to_bot_link_RowClass } from "../../../dbschema";

export class BotLinkContainerModel extends BaseContainerModel{
  alg_bot_to_bot_link: alg_bot_to_bot_link_RowClass = new alg_bot_to_bot_link_RowClass();
}
